import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  DEL_PACKAGE_IMAGES,
  ADD_PACKAGE_IMAGES,
  UPD_PACKAGE_IMAGES,
} from "../../../store/constants/serviceEndpoint";
import * as enums from "../../../common/enum";

const initData = {};

export default function ConfigChannelPackageImage({
  eventId,
  listChannel = [],
  listChannelPackage = [],
  listImage = [],
  data = [],
  onReloadData,
}) {
  // console.log("data", data, listImage, listChannel, listChannelPackage);
  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState(initData);
  const [loading, setLoading] = useState(false);

  const onCancel = (e) => {
    if (e) e.preventDefault();
    setVisible(false);
    setItem(initData);
  };

  const onShowItem = (e, item) => {
    e.preventDefault();
    setItem(item);
    console.log("item", item);
    setVisible(true);
  };

  const onDeleteItem = (e, Id) => {
    e.preventDefault();
    Swal.fire({
      title: 'Thông báo',
      text: "Bạn có muốn xóa cài đặt này không ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý!',
      cancelButtonText: 'Trở về'
    }).then((result) => {
      if (result.value) {
        axiosWithHeaders("post", DEL_PACKAGE_IMAGES, {Id})
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              Swal.fire("Thông báo", "Xoá cài đặt thành công !", "success");
              if (typeof onReloadData === "function") onReloadData(eventId);
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((error) => alert(error.toString()))
        .finally(() => {
          setLoading(false);
        });
      }
    })
  };

  const onAddItem = (e) => {
    e.preventDefault();

    const objAdd = {
      eventId: eventId,
      ChannelId: item.channelId,
      EventImageId: item.eventImageId,
      PackageId: item.packageId,
      IsRequied: item.isRequire ? 1 : 0,
    };

    // console.log("objAdd", objAdd);
    setLoading(true);
    axiosWithHeaders("post", ADD_PACKAGE_IMAGES, objAdd)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Thêm thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((error) => {
        Swal.fire("Lỗi", error.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onUpdateItem = (e) => {
    e.preventDefault();
    const objUpd = {
      id: item.id,
      eventId: eventId,
      ChannelId: item.channelId,
      EventImageId: item.eventImageId,
      PackageId: item.packageId,
      IsRequied: item.isRequire ? 1 : 0,
    };

    setLoading(true);
    axiosWithHeaders("post", UPD_PACKAGE_IMAGES, objUpd)
      .then((response) => {
        // console.log(response);
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            Swal.fire("Thông báo", "Cập nhật thành công", "success");
            setItem(null);
            setVisible(false);
            if (typeof onReloadData === "function") onReloadData(eventId);
          } else {
            Swal.fire("Lỗi", message, "error");
          }
        }
      })
      .catch((error) => {
        Swal.fire("Lỗi", error.toString(), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const footer = (
    <>
      {item && item.id ? (
        <Button
          label="Cập nhật"
          icon="pi pi-check"
          onClick={onUpdateItem}
          className="p-button-raised"
          loading={loading}
        />
      ) : (
        <Button
          label="Xác nhận"
          icon="pi pi-check"
          onClick={onAddItem}
          className="p-button-raised"
          loading={loading}
        />
      )}
      <Button
        label="Hủy"
        icon="pi pi-times"
        onClick={onCancel}
        className="p-button-raised p-button-secondary"
        loading={loading}
      />
    </>
  );

  const cellTemplate = (row, column) => {
    const field = column.field;
    switch (field) {
      case "isRequire":
        return <Checkbox checked={row["isRequire"]} disabled></Checkbox>;
      case "action":
        return (
          <div className="d-flex p-1 justify-content-center">
            <Button
              icon="pi pi-pencil"
              className="p-button-success p-button-raised"
              style={{ marginRight: 7, width: 35 }}
              onClick={(e) => onShowItem(e, row)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-raised"
              style={{ width: 35 }}
              onClick={(e) => onDeleteItem(e, row.id)}
              disabled={!row.id ? true : false}
            />
          </div>
        );
      default:
        return (
          <DataTable
            value={row.dataPackage}
            headerColumnGroup={null}
            rowGroupMode="rowspan"
            sortField="packageName"
            // sortOrder={1}
            groupField="packageId"
            emptyMessage="Hoạt động này chưa tạo suất nào...."
          >
            <Column field="packageName" header="Suất" />
            <Column field="nameImage" header="Tên hình" />
            <Column
              field="isRequire"
              header="Bắt buộc"
              body={(row, column) => cellTemplate(row, column)}
              style={{ textAlign: "center" }}
              className={"p-col-fixed"}
            />
            <Column
              field="action"
              body={(row, column) => cellTemplate(row, column)}
              style={{ textAlign: "center", width: 120 }}
              className={"p-col-fixed"}
            />
          </DataTable>
        );
    }
  };

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-center`}
        >
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT HÌNH THEO SUẤT
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <DataTable
            value={data}
            rowGroupMode="rowspan"
            sortField="ChannelName"
            sortOrder={1}
            groupField="channelId"
            emptyMessage="Hoạt động này chưa tạo suất nào...."
          >
            <Column field="channelName" header="Kênh" style={{ width: 120 }} />
            <Column
              header="Hình theo suất"
              body={(row, column) => cellTemplate(row, column)}
            />
          </DataTable>
        </div>
      </div>

      <Dialog
        header={item && item.id ? "Cập nhật" : "Thêm mới"}
        footer={footer}
        visible={visible}
        style={{ width: "600px" }}
        modal={true}
        onHide={onCancel}
      >
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtChannelName">Kênh</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="txtChannelName"
              value={item && item.channelId ? item.channelId : 0}
              optionValue="id"
              optionLabel="name"
              options={listChannel}
              onChange={(e) => {
                setItem({ ...item, channelId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm kênh"
              filterBy="id,name"
              placeholder="Chọn kênh"
              style={{ width: "100%" }}
              disabled
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtPackageName">Suất</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="txtPackageName"
              value={item && item.packageId ? item.packageId : 0}
              optionValue="id"
              optionLabel="name"
              options={listChannelPackage}
              onChange={(e) => {
                setItem({ ...item, packageId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm suất"
              filterBy="id,name"
              placeholder="Chọn suất"
              style={{ width: "100%" }}
              disabled
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtImageName">Loại hình</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="txtImageName"
              value={item && item.eventImageId ? item.eventImageId : 0}
              optionValue="id"
              optionLabel="name"
              options={listImage}
              onChange={(e) => {
                setItem({ ...item, eventImageId: e.value });
              }}
              filter={true}
              filterPlaceholder="Tìm kênh"
              filterBy="id,name"
              placeholder="Chọn hình"
              style={{ width: "100%" }}
              disabled
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right"></div>
          <div className="col-md-6">
            <Checkbox
              checked={item && item.isRequire ? item.isRequire : false}
              inputId="cb2"
              onChange={(e) => setItem({ ...item, isRequire: e.checked })}
            ></Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              &nbsp;Bắt buộc ?
            </label>
          </div>
        </div>
      </Dialog>
    </>
  );
}
